import { createContext, useContext } from "react";

const AiChatCtx = createContext(null);

export function AiChatProvider({ children, value }) {
  return <AiChatCtx.Provider value={value}>{children}</AiChatCtx.Provider>;
}

export function useAiChat() {
  return useContext(AiChatCtx);
}
